module.exports = __webpack_public_path__ + "img/project9_3.jpg.2c4622f2.webp";